<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-gap-2
      tw-px-6
      tw-py-4
      tw-border-solid
      tw-border-x-0
      tw-bg-sf-snow-lighter
      tw-border-b
      tw-border-t-0
    "
    :class="theme.commentDivider"
  >
    <SfSkeletonLoader width="25%" />
    <SfSkeletonLoader />
  </div>
</template>

<script setup lang="ts">
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'
import { commsTheme } from '@app/shared/comms-theme'

const theme = commsTheme()
</script>
